import { TxtAttach } from "./index.model";

export class MobileAttach {
    constructor() { }

    SignatureID: string;
    JurisID: number;
    ImgID: string;
    PhoneNumber: string;
    MobileLink: string;
    ImageFileName: string;
    ImageData: string;
    IPAddress: string;
    Latitude: number;
    Langitude: number;
    MobileSignDttmUTC: Date;
    CreatedDttmUTC: Date;
    Custom1: string;
    Custom2: string;
    ImageDataJson: string;
    IsValid: boolean;
    SignatureFile: TxtAttach;
    FName: string;
    LName: string;
    TextData: string;
    Type: string;
    AuthCode: number;
    ImageFileAttach: EAttachment[];
   
}

export class EAttachment {

    constructor() { }

    public SignatureID: string;
    public ImageFileName: string;
    public ImageData: string;
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/mobile-attach.model.ts